import {Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {ReturnDetailService} from "../../services/return-detail.service";
import {Subscription} from "rxjs";
import {ReturnDetailInfoDto} from "../../models/return.models";

@Component({
  selector: 'app-return-detail-component',
  templateUrl: './return-detail-component.component.html',
  styleUrls: ['./return-detail-component.component.scss']
})
export class ReturnDetailComponentComponent implements OnInit, OnDestroy{
  @Output() copyDetail: EventEmitter<void> = new EventEmitter<void>()

  @ViewChild('modalBlock') modalBlock: ElementRef | undefined

  returnDetail: ReturnDetailInfoDto | undefined | null

  subs: Subscription[] = []

  text = ''

  constructor(
    private returnDetailService: ReturnDetailService
  ) {
  }

  ngOnInit() {
    this.initModal()
  }

  ngOnDestroy() {
    this.subs.forEach(item => item.unsubscribe())
  }

  initModal() {
    this.subs.push(this.returnDetailService.returnDetailService$.subscribe({
      next: (res) => {
        this.returnDetail = res
        setTimeout(() => {
          let arr: string[] = []
          let allBlock = this.modalBlock?.nativeElement.querySelectorAll('.info-block__line')

          allBlock.forEach((item: { querySelector: (arg0: string) => { (): any; new(): any; innerText: any; }; }) => {
            let left = item.querySelector('.info-block__line-left').innerText
            let right = item.querySelector('.info-block__line-right').innerText
            arr.push(`${left}: ${right} \n`)
          })

          this.text = arr.join(' ')
        }, 0)
      }
    }))
  }


  copyDetailEvent(event: boolean) {
    this.copyDetail.emit()
  }
}
